export default __webpack_public_path__ + "static/media/sweet-pie.9356ff95.jpg";